<template>
    <div>
        <span>
            <div class="y-choseTop">
                <div class="rights">
                    <span class="el-icon-arrow-left" @click="prevWeek"></span>
                    <span class="el-icon-arrow-right" @click="nextWeek"></span>
                </div>
            </div>
            <div class="y-tables">
                <el-table
                    :data="tabRows"
                    :row-style=rowStyle
                    border
                    style="width: 100%"
                    :key="timestamp"
                    height="500">
                        <el-table-column
                            header-align="center"
                            prop="fieldName"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            v-for="propitem in tabHeader.columns"
                            :key="propitem"
                            header-align="center"
                            align="center"
                            :prop="propitem"
                            :label="tabHeader.columnMap[propitem]">
                            <template slot-scope="scope">
                                <div class="y-allTips">
                                    <div ref="current"
                                            :class="['current','y-topTips',getDayRow(scope.row,propitem).status == -1 ? '' : (getDayRow(scope.row,propitem).status == 0 ? 'greens' : 'reds')]"
                                            @click="getThisMessage(scope.row,getDayRow(scope.row,propitem),propitem,$event)">
                                      <el-popover trigger="hover" width="200px" title="预约情况">
                                        <p>{{getDayRow(scope.row,propitem).countDesc}}</p>
                                        <el-progress style="margin-top: 5px;" type="line" color="#409eff" :stroke-width="22" :format="processMchFormat" :percentage="getMachsPrecent(getDayRow(scope.row,propitem))" text-inside/>
                                        <el-progress style="margin-top: 5px;" type="line" :stroke-width="22" :format="processCapFormat" :percentage="getCapPrecent(getDayRow(scope.row,propitem))" text-inside/>
                                        <el-button type="text" slot="reference">全天</el-button>
                                      </el-popover>
                                    </div>
                                    <div ref="current"
                                            :class="['current','y-botTips-am',getAmRow(scope.row,propitem).status == -1 ? '' : (getAmRow(scope.row,propitem).status == 0 ? 'greens' : 'reds')]"
                                            @click="getThisMessage(scope.row,getAmRow(scope.row,propitem),propitem,$event)">
                                      <el-popover trigger="hover" width="200px" title="预约情况">
                                        <p>{{getAmRow(scope.row,propitem).countDesc}}</p>
                                        <el-progress style="margin-top: 5px;" type="line" color="#409eff" :stroke-width="22" :format="processMchFormat" :percentage="getMachsPrecent(getAmRow(scope.row,propitem))" text-inside/>
                                        <el-progress style="margin-top: 5px;" type="line" :stroke-width="22" :format="processCapFormat" :percentage="getCapPrecent(getAmRow(scope.row,propitem))" text-inside/>
                                        <el-button type="text" slot="reference">上午</el-button>
                                      </el-popover>
                                    </div>
                                    <div ref="current"
                                            :class="['current','y-botTips-pm',getPmRow(scope.row,propitem).status == -1 ? '' : (getPmRow(scope.row,propitem).status == 0 ? 'greens' : 'reds')]"
                                            @click="getThisMessage(scope.row,getPmRow(scope.row,propitem),propitem,$event)">
                                      <el-popover trigger="hover" width="200px" title="预约情况">
                                        <p>{{getPmRow(scope.row,propitem).countDesc}}</p>
                                        <el-progress style="margin-top: 5px;" type="line" color="#409eff" :stroke-width="22" :format="processMchFormat" :percentage="getMachsPrecent(getPmRow(scope.row,propitem))" text-inside/>
                                        <el-progress style="margin-top: 5px;" type="line" :stroke-width="22" :format="processCapFormat" :percentage="getCapPrecent(getPmRow(scope.row,propitem))" text-inside/>
                                        <el-button type="text" slot="reference">下午</el-button>
                                      </el-popover>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                </el-table>
            </div>
        </span>
    </div>
</template>
<script>
export default {
    data(){
        return{
            type: '1',
            tabHeader: {
                columns: [],
                columnMap: {},
            },
            tabRows: [],
            timestamp: "1",
            rowStyle: {
                height: '60px',
            },
            curApplyInfo: {},
            setimerules: {start:{'1':'08:00:00','2':'13:00:00','3':'08:00:00'},end:{'1':'12:00:00','2':'18:00:00','3':'18:00:00'}}
        }
    },
    mounted() {
        // this.getSetimerules()
    },
    methods:{
        openChosePlace(type) {
            this.type = type;
            this.getAllPlaceStatus();
        },
        getSetimerules() {
            this.$http.post('/suit/getSetimerules').then(({data}) => {
                if (data.code === '1') {
                    this.setimerules = data.data;
                }
            })
        },
        getAllPlaceStatus(startdate) {
            let params = {
                startdate: startdate,
                fieldType: this.type,
                properties: this.type,
            }
            this.$http.post('/suit/venueList', params).then(({data}) => {
                if (data.code === '1') {
                    this.tabHeader = data.data.header || {};
                    this.tabRows = data.data.rows || [];
                    console.log('预约新增tableData', this.tabRows)
                    this.timestamp = new Date().getTime().toString(10);
                }
            })
        },
        processMchFormat(precentage){
          return "机位剩余："+precentage+"%";
        },
        processCapFormat(precentage){
          return "进场人数剩余："+precentage+"%";
        },
        //计算机位占比
        getMachsPrecent(obj){
          let total=obj.totalMchs;
          if (total<1){
            return 0;
          }
          let mch=obj.machines;
          let rate=((total-mch)/total)*100;
          return rate;
        },//计算机位占比
        getCapPrecent(obj){
          let total=obj.totalCapcs;
          if (total<1){
            return 0;
          }
          let mch=obj.capacitys;
          let rate=((total-mch)/total)*100;
          return rate;
        },
        prevWeek() {
            let filter = "";
            if (this.tabHeader.columns && this.tabHeader.columns.length > 0) {
                let datestr = this.tabHeader.columns[0];
                let starts = new Date(datestr);
                starts = this.addDate(starts, -7)
                filter = this.formatDate(starts,"YYYY-MM-dd")
            }

            this.getAllPlaceStatus(filter);
        },
        nextWeek() {
            let filter = "";
            if (this.tabHeader.columns && this.tabHeader.columns.length > 0) {
                let datestr = this.tabHeader.columns[this.tabHeader.columns.length - 1];
                let starts = new Date(datestr);
                starts = this.addDate(starts, 1)
                filter = this.formatDate(starts,"YYYY-MM-dd")
            }
            this.getAllPlaceStatus(filter);
        },
        addDate(date, n) {
            date.setDate(date.getDate() + n);
            return date;
        },
        //格式化日期 Y-年份 M-月份 d-日份
        formatDate(date, format) {
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            let day = date.getDate();
            day = day < 10 ? "0" + day : day;
            return format.replace("YYYY", y).replace("MM", m).replace("dd", day);
        },
        getThisMessage(row, applyvo, datestr, event) {//场地弹框
            let currents = document.querySelectorAll('.current');
            for (let i = 0; i < currents.length; i++) {
                currents[i].style.cssText = 'border: 0';
            }
            if (applyvo.status < 9) {
                event.currentTarget.style.border = '2px solid #2568ec';
                this.curApplyInfo.fieldName = row.fieldName;
                this.curApplyInfo.fieldId = row.fieldId;
                this.curApplyInfo.applyTime = datestr +' '+ this.getStartTime(applyvo.timeInteval);
                this.curApplyInfo.useEndTime = datestr + ' '+ this.getEndTime(applyvo.timeInteval);
                this.curApplyInfo.applyTimeInterval = applyvo.timeInteval;
                this.$emit('getMessage',this.curApplyInfo)
            }
        },
        getDayRow(row, propitem) {
            let day = row.dayDateMap[propitem]
            return day ? day : {};
        },
        getAmRow(row, propitem) {
            let day = row.amDateMap[propitem]
            return day ? day : {};
        },
        getPmRow(row, propitem) {
            let day = row.pmDateMap[propitem]
            return day ? day : {};
        },
        getEndTime(type) {//获取结束时间
            let map=this.setimerules.end;
            return map[type];
        },
        getStartTime(type) {//获取开始时间
            let map=this.setimerules.start;
            return map[type];
        },
    }
}
</script>
<style lang="less" scoped>
.y-choseTop {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .rights {
      display: flex;

      span {
        width: 36px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #cccccc;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
        cursor: pointer;
      }

      span:hover {
        color: #ffffff;
        background: #2568ec;
        border: 0;
      }
    }
}

  .greens {
    background: orange;
    color: #ffffff;
  }

  .reds {
    background: red;
    cursor: not-allowed;
    color: #ffffff;
  }

  .y-tables {
    margin-top: 10px;

    /deep/ .el-table td, .el-table--medium td {
      padding: 0;

      .cell {
        padding: 0;
      }
    }

    .y-allTips {
      height: 150px;
      display: flex;
      flex-wrap: wrap;

      .y-topTips, .y-botTips-am, .y-botTips-pm {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .y-topTips {
        width: 100%;
        height: 75px;
        border-bottom: 1px solid #ebeef5 !important;
      }

      .y-botTips-am {
        width: 50%;
        height: 75px;
        border-right: 1px solid #ebeef5 !important;
      }

      .y-botTips-pm {
        width: 50%;
        height: 75px;
      }
    }
  }
</style>
